/**
 * Cloudflare Stream utilities
 */

/**
 * Get Cloudflare Stream customer ID from environment
 * @returns {string} Customer ID
 */
export const getStreamCustomerId = () => {
  return process.env.REACT_APP_CLOUDFLARE_STREAM_CUSTOMER_ID || 'customer-b6dep35w7xo2ew5y';
};

/**
 * Generate Cloudflare Stream iframe URL
 * @param {string} videoId - Video ID
 * @param {Object} options - Options for the iframe
 * @param {string} [options.poster] - Poster image URL
 * @param {number} [options.time] - Start time in seconds
 * @param {number} [options.height] - Poster height
 * @returns {string} Complete iframe URL
 */
export const getStreamIframeUrl = (videoId, options = {}) => {
  const customerId = getStreamCustomerId();
  const baseUrl = `https://${customerId}.cloudflarestream.com/${videoId}/iframe`;
  
  const params = new URLSearchParams();
  
  if (options.poster) {
    params.append('poster', options.poster);
  }
  
  if (options.time !== undefined) {
    params.append('time', options.time);
  }
  
  if (options.height) {
    params.append('height', options.height);
  }
  
  return `${baseUrl}${params.toString() ? '?' + params.toString() : ''}`;
};

/**
 * Generate Cloudflare Stream thumbnail URL
 * @param {string} videoId - Video ID
 * @param {Object} options - Options for the thumbnail
 * @param {number} [options.time] - Time in seconds for thumbnail
 * @param {number} [options.height] - Thumbnail height
 * @param {number} [options.width] - Thumbnail width
 * @returns {string} Complete thumbnail URL
 */
export const getStreamThumbnailUrl = (videoId, options = {}) => {
  const customerId = getStreamCustomerId();
  const baseUrl = `https://${customerId}.cloudflarestream.com/${videoId}/thumbnails/thumbnail.jpg`;
  
  const params = new URLSearchParams();
  
  if (options.time !== undefined) {
    params.append('time', options.time);
  }
  
  if (options.height) {
    params.append('height', options.height);
  }
  
  if (options.width) {
    params.append('width', options.width);
  }
  
  return `${baseUrl}${params.toString() ? '?' + params.toString() : ''}`;
};
